import { API } from "api";

export const getFnstrListAPI = (req) => {
    return API.get("api/functionalstructure/getall?page=0&size=0")
        .then((res) => res);
};


